import Button from '../common/components/Button'
import React from 'react'

import './ImportButton.scss'

export function ImportButton ({ onClick = () => {} }) {
  return (
    <Button className={'import-button'} onClick={() => onClick()}>or import cop-file...</Button>
  )
}